





































import { Component, Prop, Vue } from "vue-property-decorator";

interface ISelectOption {
  value: string | number;
  text: string;
}

@Component({ name: "standart-select" })
class StandartSelect extends Vue {
  @Prop({ type: [String, Number, Array], default: null })
  value!: string | number | Array<string | number> | null;
  @Prop({ type: Array, default: () => [] }) options!: ISelectOption[];
  @Prop({ type: Boolean, default: false }) multiple!: boolean;
  @Prop({ type: String, default: "sm" }) size!: "sm" | "md";
  @Prop({ type: String, default: "" }) placeholder!: string;

  menuOpen = false;

  get valueList(): Array<string | number> {
    return Array.isArray(this.value) ? this.value : [];
  }

  get selectedOptions(): ISelectOption[] {
    if (this.multiple)
      return this.options.filter((option) =>
        this.valueList.includes(option.value)
      );
    const option = this.options.find((option) => option.value === this.value);
    return option ? [option] : [];
  }

  get hasSelection(): boolean {
    return this.selectedOptions.length > 0;
  }

  get displayText(): string {
    if (!this.hasSelection) return this.placeholder;
    return this.selectedOptions.map((option) => option.text).join(", ");
  }

  isSelected(option: ISelectOption): boolean {
    return this.multiple
      ? this.valueList.includes(option.value)
      : option.value === this.value;
  }

  onOptionClick(value: string | number, event: Event): void {
    if (this.multiple) event.stopPropagation();
    this.select(value);
  }

  select(value: string | number): void {
    if (this.multiple) {
      const list = [...this.valueList];
      const i = list.indexOf(value);
      if (i > -1) list.splice(i, 1);
      else list.push(value);
      this.$emit("input", list);
      this.$emit("change", list);
      return;
    }
    this.$emit("input", value);
    this.$emit("change", value);
  }
}
export default StandartSelect;
